module.exports = __webpack_public_path__ + "img/温姆2_1.552a985f.png";